import { FileReader, FileWriter } from '@/platform'
class FontProperty {
    public Font_Size: number = 0 // 字号
    public Font_name: string = '' // 字体名称
    public Font_color: string = '' // 字体颜色

    constructor(reader: FileReader)
    constructor(name?: string, size?: number, color?: string)
    constructor(name: string | FileReader = '', size: number = 0, color?: string) {
        if (typeof name === 'string') {
            this.Font_Size = size
            this.Font_name = name
            this.Font_color = color ?? '255,255,255'
        } else if(name instanceof FileReader) {
            this.Font_Size = name.readInt()
            this.Font_name = name.readString()
            this.Font_color = name.readString()
        }
    }

    readBin(reader: FileReader): void {
        this.Font_Size = reader.readInt()
        this.Font_name = reader.readString()
        this.Font_color = reader.readString()
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.Font_Size)
        writer.writeString(this.Font_name)
        writer.writeString(this.Font_color)
    }

    readVersionedOui(reader: FileReader): void {
        this.Font_Size = reader.readInt()
        this.Font_name = reader.readString()
        this.Font_color = reader.readString()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeInt(this.Font_Size)
        writer.writeString(this.Font_name)
        writer.writeString(this.Font_color)
        writer.writerLength()
    }

    writeMallBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}
export default FontProperty
